// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__v2b5m","loadingWrap":"styles_loadingWrap__BGCas"};